import React, { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";

interface ArticleCardProps {
  title: string;
  articleCount: number;
  icon: ReactNode;
}

const StyledCard = styled(Card)`
  height: 100%;
  transition: transform 0.2s ease-in-out;
  &:hover {
    transform: translateY(-4px);
    cursor: pointer;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 2rem;
  color: var(--primary-bg);
`;

const ArticleCard: React.FC<ArticleCardProps> = ({
  title,
  articleCount,
  icon,
}) => {
  return (
    <Link
      to={`/help/${title.toLowerCase()}`}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <StyledCard>
        <Card.Body>
          <IconWrapper>{icon}</IconWrapper>
          <Card.Title className="mb-2">{title}</Card.Title>
          <Card.Text className="text-muted">
            {articleCount} {articleCount === 1 ? "article" : "articles"}
          </Card.Text>
        </Card.Body>
      </StyledCard>
    </Link>
  );
};

export default ArticleCard;
